import { render, staticRenderFns } from "./SkeletonShopNews.vue?vue&type=template&id=ff34826a&"
import script from "./SkeletonShopNews.vue?vue&type=script&lang=js&"
export * from "./SkeletonShopNews.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonShopNews.vue?vue&type=style&index=0&id=ff34826a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports